'use client';

import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';

export const FormNavigation = ({
  prevDisabled = false,
  nextDisabled = false,
  prevAction,
  nextAction,
  prevTitle,
  nextTitle,
}: FormNavigationProps) => {
  const t = useTranslations('FORM');

  const prevButtonTitle = prevTitle || t('PREVIOUS_BUTTON');
  const nextButtonTitle = nextTitle || t('NEXT_BUTTON');

  return (
    <nav className="formNavigation">
      <button
        type="button"
        data-testid="form-navigation-prev-btn"
        className="formNavigation__button"
        title={prevButtonTitle}
        disabled={prevDisabled}
        onClick={prevAction}
      >
        <VpIcon name="arrow-up" />
      </button>
      <button
        type="button"
        data-testid="form-navigation-next-btn"
        className="formNavigation__button"
        title={nextButtonTitle}
        disabled={nextDisabled}
        onClick={nextAction}
      >
        <VpIcon name="arrow-down" />
      </button>
    </nav>
  );
};

export interface FormNavigationProps {
  prevDisabled: boolean;
  nextDisabled: boolean;
  prevAction: () => void;
  nextAction: () => void;
  prevTitle?: string;
  nextTitle?: string;
}
